export default "__VITE_ASSET__46bea024__"